export default {
  data() {
    return {
      SCJYForm: {
        zyywjcpsm: "",
        zyywgm: "",
        ywjsgzxm: "",
        ywjwtzxm: "",
        nsgm: "",
        sjzj: "",
        jzc: "",
        xssr: "",
        yysr: "",
        yfjfzc: "",
        jlr: ""
      },
      zyywgmList: [
        { name: "100万以下（含100）", code: "zygm_1" },
        { name: "100-500万（含500）", code: "zygm_2" },
        { name: "500-1000万（含1000）", code: "zygm_3" },
        { name: "1000-5000万（含5000）", code: "zygm_4" },
        { name: "5000万-1亿（含1亿）", code: "zygm_5" },
        { name: "1亿以上", code: "zygm_6" }
      ],
      nsgmList: [
        { name: "50万以下（含50）", code: "1" },
        { name: "50-200万（含200）", code: "2" },
        { name: "200-500万（含500）", code: "3" },
        { name: "500-1000万（含1000）", code: "4" },
        { name: "1000-5000（含5000）", code: "5" },
        { name: "5000万以上", code: "6" }
      ]
    };
  },
  methods: {
    sfyygxqChange() {
      this.RLZYForm.ldygxql = "";
      this.$refs["RLZYForm"].clearValidate();
    },
    numberTemplate(data, name) {
      console.log(data.replace(/[^\d.]/g, ""));
      this.SCJYForm[name] = data.replace(/[^\d.]/g, "");
    }
  }
};
